export enum GBMessages {
  GET_EXTENSION_STATE = 'getExtensionState',
  CLEAR_CACHE = 'clearCache',
  RELOAD_EXTENSION = 'reloadExtension',
  RESYNC_EXTENSION = 'resyncExtension',
  OPEN_HELP = 'openChromeHelp',
  OPEN_DEVICE_INFO = 'openDeviceInfo',
  CHECK_VERSION = 'checkVersion',
  FIX_VERSION = 'fixVersion',
  OPEN_FAQ = 'openFAQ',
}
